import between from '@inquisitive/between';

import { DIRECTION_LEFT, DIRECTION_RIGHT } from 'webclient.constants';

export function getReorderSort<T extends { sort: string | null }>(
  list: T[],
  position: number,
  direction: typeof DIRECTION_LEFT | typeof DIRECTION_RIGHT
): string {
  if (list.length === 0) {
    return between.between(between.lowest, between.highest);
  }

  if (position === 0 && list[0].sort) {
    return between.between(between.lowest, list[0].sort);
  }

  if (position === list.length - 1) {
    const lowSort = list[position].sort;
    if (lowSort) {
      return between.between(lowSort, between.highest);
    }
  }

  let leftSort;
  let rightSort;

  if (direction === DIRECTION_LEFT) {
    leftSort = list[position - 1].sort || between.lowest;
    rightSort = list[position]?.sort || between.highest;
  } else {
    leftSort = list[position].sort || between.lowest;
    rightSort = list[position + 1]?.sort || between.highest;
  }

  return between.between(leftSort, rightSort);
}
